import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class OrderDateSection  {
    _originalTypeClassName = "ekylikeio.BO.OrderDateSection";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
OrderDateSection.translate = translateService;
}
this.StudentSections = [];
this.Id = null;
this.Date = null;
this.TotalPrice = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Date:any;
TotalPrice:any;
StudentSections:any;
Order:any;
static setStudentSections = ($this, items) => {
                if (items == null) items = [];
                if ($this.StudentSections == null) $this.StudentSections = [];

                const copyItems = Common.cloneObject(items);

                while ($this.StudentSections.length > 0) {
                    Domain.OrderDateSection.removeStudentSections($this, $this.StudentSections[0]);
                }

                Domain.OrderDateSection.addManyStudentSections($this, copyItems);
            }
static addManyStudentSections = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.OrderDateSection.addStudentSections($this, items[i]);
                }
            }
static addStudentSections = ($this, item) => {
                if ($this.StudentSections == null) $this.StudentSections = [];
                if (item == null || $this.StudentSections.indexOf(item) > -1) return;
                $this.StudentSections.push(item);
if (item.OrderDateSection != $this) {
Domain.OrderSection.setOrderDateSection(item, $this);
}
}
static addRangeStudentSections = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.OrderDateSection.addStudentSections($this, item));
            }
static removeStudentSections = ($this, item) => {
                if ($this == null || $this.StudentSections == null || $this.StudentSections.indexOf(item) === -1) return;
                var _index = $this.StudentSections.indexOf(item);
                $this.StudentSections.splice(_index, 1);
item.OrderDateSection = null;
}
static clearStudentSections = ($this) => { $this.StudentSections = null; }
static setOrder = ($this, value) => {
var oldValue = $this.Order;
$this.Order = value;
if (value != null) {
if (oldValue != null) {
Domain.Order.removeDateSections(oldValue, $this);
}
Domain.Order.addDateSections(value, $this);
}
}

static UpdateTotalPrice($this: any): any{for (let _isection = 0; _isection < ($this?.StudentSections == null ? 0 : $this?.StudentSections.length); _isection++) {let section = $this?.StudentSections[_isection];Domain.OrderSection.UpdatePrice(section);}
$this.TotalPrice = $this?.StudentSections?.linq?.sum((s) => s?.TotalPrice);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}